import { render, staticRenderFns } from "./editarOrdem.vue?vue&type=template&id=06d02a33"
import script from "./editarOrdem.vue?vue&type=script&lang=js"
export * from "./editarOrdem.vue?vue&type=script&lang=js"
import style0 from "./editarOrdem.vue?vue&type=style&index=0&id=06d02a33&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports